import { CSSProperties, ReactNode } from 'react'

type TablePanelProps = {
  children: ReactNode
  style?: CSSProperties
  'data-testid'?: string
}

// Frames a table (and any header/toolbar row above it) in the Trellis card
// surface — a 1px outline border with the small radius — so every list in the
// console reads as one bordered panel. Layout (flex, sizing, scroll) is left to
// the caller via `style`.
const TablePanel = ({ children, style, 'data-testid': testId }: TablePanelProps) => (
  <div
    data-testid={testId}
    style={{
      border: '1px solid var(--trellis-color-outline)',
      borderRadius: 'var(--trellis-radius-sm)',
      overflow: 'hidden',
      ...style,
    }}
  >
    {children}
  </div>
)

export default TablePanel
